export default __webpack_public_path__ + "static/media/location--4.9f55720a.jpg";